import { render, staticRenderFns } from "./rewardInviteHelpEdit.vue?vue&type=template&id=810571da&scoped=true&"
import script from "./rewardInviteHelpEdit.vue?vue&type=script&lang=js&"
export * from "./rewardInviteHelpEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810571da",
  null
  
)

export default component.exports